import { Component, Input, OnInit } from '@angular/core';

import { UserService, DataService, OperationsService, AuthenticationService, StorageService, LoansService } from '../../_services/index';

@Component({
  selector: 'app-checkpartnerstatus',
  templateUrl: './checkpartnerstatus.component.html',
  styleUrls: ['./checkpartnerstatus.component.css']
})
export class CheckpartnerstatusComponent implements OnInit {
  @Input() batch_id : any;
  @Input() partner_request_id : any;
  loading = false;
  data:any;
  constructor(public loansService: LoansService ,public authService: AuthenticationService,
    private DataService: DataService, public operationsService: OperationsService,
    public storageService: StorageService) { }

  ngOnInit() {
    this.loading = true;
    this.loansService.getMerchantStatus(this.batch_id, this.partner_request_id)
      .subscribe(data => {
        this.data = data.data;
        console.log(data)
      });
  }

}
